/*
 * @Author: Src
 * @Date: 2025-08-06 09:57:50
 * @LastEditTime: 2025-08-06 21:27:19
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/base.service.ts
 * @Description: 基础服务
 */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';
import { City } from '@/common/interface/shop';
import { freeze } from '@/common/utils';
import { BASE_CAR_URL } from '@/common/constant';

@injectable()
export default class BaseService {
  @inject(HttpClient)
  protected http!: HttpClient;

  /**
   * 获取城市里列表
   *
   * @param {boolean} [covered]
   * @return {Promise<City[]>}
   * @memberof BaseService
   */
  async getCityList(payload: {
    covered?: boolean;
    joined?: boolean;
    aggregation?: boolean;
  } = {
      // covered: true,
      joined: true,
      aggregation: true,
    }): Promise<City[]> {
    const query: string[] = [];
    Object.entries(payload).forEach(([key, value]) => {
      query.push(`${key}=${value}`);
    });
    const data: City[] = await this.http.get(`/region?${query.join('&')}`);
    return freeze(data);
  }


  /**
   * 获取所有区域
   *
   * @return {*}  {Promise<Address[]>}
   * @memberof GeoService
   */
  async getAllRegion() {
    try {
      const regionCity = localStorage.getItem('regionCity');
      if (regionCity) {
        return JSON.parse(regionCity);
      }
      const data = await this.http.get(`${BASE_CAR_URL}/region/all`) as any[];
      localStorage.setItem('regionCity', JSON.stringify(data));
      return data;
    } catch (error) {
      return null;
    }
  }
}
